var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2c3333",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Yin_and_yang"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256.0085,
    cy: 157.5689,
    r: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,46C140.02,46,46,140.02,46,256s94.02,210,210,210,210-94.02,210-210S371.98,46,256,46Zm.0085,343.4439a35,35,0,1,1,35-35A35.001,35.001,0,0,1,256.0085,389.4439ZM256,256a98.3646,98.3646,0,0,0-66.1462,171.2338C121.1654,400.6036,72.25,333.9831,72.25,256,72.25,154.6786,154.6786,72.25,256,72.25a182.46,182.46,0,0,1,66.142,12.514A98.3635,98.3635,0,0,1,256,256Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0327a22b12486cf2897f21cc34957bba.svg";
export { ForwardRef as ReactComponent };